// Helpers per Web Push
import { api } from './api.js';

export function isPushSupported() {
  return (
    'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
  );
}

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export function currentPermission() {
  return typeof Notification !== 'undefined' ? Notification.permission : 'default';
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from(rawData, (c) => c.charCodeAt(0));
}

export async function ensureSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const { publicKey } = await api.get('/push/vapid-public-key');
    if (!publicKey) {
      throw new Error('VAPID non configurate sul server');
    }
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await api.post('/push/subscribe', { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribe() {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.post('/push/unsubscribe', { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe();
  }
}
